<template>
  <basic-container>
    <div class="emergency-page">
      <el-form :inline="true" :model="query" size="small">
        <el-form-item label="事件标题">
          <el-input v-model="query.eventName" clearable placeholder="请输入事件标题" />
        </el-form-item>
        <el-form-item label="事件类型">
          <el-select v-model="query.eventType" clearable placeholder="请选择">
            <el-option v-for="item in eventTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.eventStatus" clearable placeholder="请选择">
            <el-option v-for="item in eventStatusOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="优先级">
          <el-select v-model="query.urgencyLevel" clearable placeholder="请选择">
            <el-option v-for="item in urgencyOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker v-model="query.timeRange" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="table-toolbar">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openForm()">一键提报</el-button>
      </div>

      <el-table v-loading="loading" :data="tableData" border size="small" empty-text="暂无应急事件">
        <el-table-column label="事件编号" prop="eventNumber" width="160" show-overflow-tooltip />
        <el-table-column label="事件标题" prop="eventName" min-width="180" show-overflow-tooltip />
        <el-table-column label="事件类型" prop="eventType" width="120">
          <template slot-scope="{ row }">{{ optionLabel(eventTypeOptions, row.eventType) }}</template>
        </el-table-column>
        <el-table-column label="优先级" prop="urgencyLevel" width="110">
          <template slot-scope="{ row }">
            <el-tag size="small" :type="urgencyTag(row.urgencyLevel)">{{ optionLabel(urgencyOptions, row.urgencyLevel) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="来源" prop="eventSource" width="100">
          <template slot-scope="{ row }">{{ optionLabel(sourceOptions, row.eventSource) }}</template>
        </el-table-column>
        <el-table-column label="状态" prop="eventStatus" width="130">
          <template slot-scope="{ row }">
            <el-tag size="small" :type="statusTag(row.eventStatus)">{{ optionLabel(eventStatusOptions, row.eventStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="发生时间" prop="occurTime" width="165" show-overflow-tooltip />
        <el-table-column label="区域" prop="areaName" width="120" show-overflow-tooltip />
        <el-table-column label="位置" prop="location" min-width="180" show-overflow-tooltip />
        <el-table-column label="操作" fixed="right" width="300">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openDetail(row)">详情</el-button>
            <el-button type="text" size="small" @click="openForm(row)">编辑</el-button>
            <el-button type="text" size="small" @click="openPlan(row)">上报</el-button>
            <el-button type="text" size="small" @click="openResponse(row)">启动响应</el-button>
            <el-button type="text" size="small" @click="submitStatus(row, 'false')">误报</el-button>
            <el-button type="text" size="small" @click="submitStatus(row, 'end')">结束</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="page-bar" background :current-page.sync="page.currentPage" :page-size.sync="page.pageSize" :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" :total="page.total" @current-change="loadList" @size-change="handleSizeChange" />

      <el-dialog :title="form.id ? '编辑应急事件' : '一键提报应急事件'" :visible.sync="formVisible" width="720px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-row :gutter="12">
            <el-col :span="12"><el-form-item label="事件标题" prop="eventName"><el-input v-model="form.eventName" maxlength="50" show-word-limit /></el-form-item></el-col>
            <el-col :span="12"><el-form-item label="事件类型" prop="eventType"><el-select v-model="form.eventType" style="width: 100%"><el-option v-for="item in eventTypeOptions" :key="item.value" :label="item.label" :value="item.value" /></el-select></el-form-item></el-col>
            <el-col :span="12"><el-form-item label="优先级" prop="urgencyLevel"><el-select v-model="form.urgencyLevel" style="width: 100%"><el-option v-for="item in urgencyOptions" :key="item.value" :label="item.label" :value="item.value" /></el-select></el-form-item></el-col>
            <el-col :span="12"><el-form-item label="发生时间" prop="occurTime"><el-date-picker v-model="form.occurTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" /></el-form-item></el-col>
            <el-col :span="12"><el-form-item label="区域编码"><el-input v-model="form.areaCode" maxlength="64" /></el-form-item></el-col>
            <el-col :span="12"><el-form-item label="区域名称"><el-input v-model="form.areaName" maxlength="128" /></el-form-item></el-col>
            <el-col :span="24"><el-form-item label="发生位置" prop="location"><el-input v-model="form.location" maxlength="200" /></el-form-item></el-col>
            <el-col :span="24"><el-form-item label="现场图片"><el-input v-model="form.sitePhoto" placeholder="上传组件联调前可填写图片地址，多个地址用逗号分隔" /></el-form-item></el-col>
            <el-col :span="24"><el-form-item label="处理方式"><el-input v-model="form.handlingMethod" type="textarea" :rows="2" maxlength="500" show-word-limit /></el-form-item></el-col>
            <el-col :span="24"><el-form-item label="事件描述"><el-input v-model="form.eventDescription" type="textarea" :rows="3" maxlength="1000" show-word-limit /></el-form-item></el-col>
          </el-row>
        </el-form>
        <span slot="footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" :loading="actionLoading" @click="submitForm">确定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="应急事件详情" :visible.sync="detailVisible" width="86%" append-to-body>
        <div v-loading="detailLoading">
          <div class="detail-grid">
            <div v-for="item in detailFields" :key="item.label" class="detail-item" :class="{ wide: item.wide }">
              <span>{{ item.label }}</span><strong>{{ item.value || '-' }}</strong>
            </div>
          </div>
          <div class="section-title">事件时间轴</div>
          <el-timeline>
            <el-timeline-item v-for="(item, index) in timelineList" :key="index" :timestamp="item.operateTime || item.time" :color="stageColor(item.stageColor)">
              <div class="timeline-title">{{ item.stageName || item.actionName }}</div>
              <div class="timeline-meta">操作人员：{{ item.operatorName || '-' }}</div>
              <div class="timeline-body">{{ item.remark || item.actionName || '-' }}</div>
            </el-timeline-item>
          </el-timeline>
          <el-empty v-if="timelineList.length === 0" description="暂无时间轴节点" />
        </div>
      </el-dialog>

      <el-dialog title="选择预案上报" :visible.sync="planVisible" width="620px" append-to-body>
        <el-form :model="operationForm" label-width="100px">
          <el-form-item label="预案" required>
            <el-select
              v-model="operationForm.planId"
              filterable
              remote
              clearable
              reserve-keyword
              :remote-method="loadPlanOptions"
              :loading="planLoading"
              placeholder="请选择应急预案"
              style="width: 100%"
            >
              <el-option
                v-for="item in planOptions"
                :key="item.id"
                :label="planOptionLabel(item)"
                :value="String(item.id)"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="上报说明"><el-input v-model="operationForm.verifyInfo" type="textarea" :rows="3" maxlength="500" show-word-limit /></el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="planVisible = false">取消</el-button>
          <el-button type="primary" :loading="actionLoading" @click="submitPlan">确定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="启动三级响应" :visible.sync="responseVisible" width="620px" append-to-body>
        <el-form :model="operationForm" label-width="100px">
          <el-form-item label="响应等级" required><el-select v-model="operationForm.responseLevel" style="width: 100%"><el-option v-for="item in responseOptions" :key="item.value" :label="item.label" :value="item.value" /></el-select></el-form-item>
          <el-form-item label="说明"><el-input v-model="operationForm.verifyInfo" type="textarea" :rows="3" maxlength="500" show-word-limit /></el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="responseVisible = false">取消</el-button>
          <el-button type="primary" :loading="actionLoading" @click="submitResponse">确定</el-button>
        </span>
      </el-dialog>
    </div>
  </basic-container>
</template>

<script>
import { getList, report, update, getDetail, reportToAuthority, startResponse, manualEnd, markFalseAlarm, getPlanList } from './api'

const eventTypeOptions = [{ label: '设备故障', value: 1 }, { label: '自然灾害', value: 2 }, { label: '人为事故', value: 3 }]
const urgencyOptions = [{ label: '特别重大', value: 1 }, { label: '重大', value: 2 }, { label: '较大', value: 3 }, { label: '一般', value: 4 }]
const eventStatusOptions = [{ label: '已提交', value: 1 }, { label: '已上报', value: 2 }, { label: '已启动响应', value: 3 }, { label: '已结束', value: 4 }, { label: '手动结束', value: 5 }, { label: '误报', value: 6 }]
const sourceOptions = [{ label: '自动上报', value: 1 }, { label: '人工上报', value: 2 }]
const responseOptions = [{ label: '一级响应', value: 1 }, { label: '二级响应', value: 2 }, { label: '三级响应', value: 3 }]

export default {
  name: 'EmergencyEventManage',
  data () {
    return {
      query: {},
      tableData: [],
      loading: false,
      page: { currentPage: 1, pageSize: 10, total: 0 },
      formVisible: false,
      form: {},
      detailVisible: false,
      detailLoading: false,
      detail: {},
      planVisible: false,
      planOptions: [],
      planLoading: false,
      responseVisible: false,
      operationForm: {},
      actionLoading: false,
      eventTypeOptions,
      urgencyOptions,
      eventStatusOptions,
      sourceOptions,
      responseOptions,
      rules: {
        eventName: [{ required: true, message: '请输入事件标题', trigger: 'blur' }],
        eventType: [{ required: true, message: '请选择事件类型', trigger: 'change' }],
        urgencyLevel: [{ required: true, message: '请选择优先级', trigger: 'change' }],
        occurTime: [{ required: true, message: '请选择发生时间', trigger: 'change' }],
        location: [{ required: true, message: '请输入发生位置', trigger: 'blur' }]
      }
    }
  },
  computed: {
    detailFields () {
      const row = this.detail || {}
      return [
        { label: '事件编号', value: row.eventNumber },
        { label: '事件标题', value: row.eventName },
        { label: '事件类型', value: this.optionLabel(this.eventTypeOptions, row.eventType) },
        { label: '优先级', value: this.optionLabel(this.urgencyOptions, row.urgencyLevel) },
        { label: '来源', value: this.optionLabel(this.sourceOptions, row.eventSource) },
        { label: '状态', value: this.optionLabel(this.eventStatusOptions, row.eventStatus) },
        { label: '发生时间', value: row.occurTime },
        { label: '区域', value: row.areaName || row.areaCode },
        { label: '位置', value: row.location, wide: true },
        { label: '处理方式', value: row.handlingMethod, wide: true },
        { label: '事件描述', value: row.eventDescription, wide: true }
      ]
    },
    timelineList () {
      return (this.detail && (this.detail.timelineList || this.detail.timelineRecords)) || []
    }
  },
  mounted () {
    this.loadList()
  },
  methods: {
    buildQuery () {
      const params = { ...this.query, page: this.page.currentPage, size: this.page.pageSize }
      if (params.timeRange && params.timeRange.length === 2) {
        params.startTime = params.timeRange[0]
        params.endTime = params.timeRange[1]
      }
      delete params.timeRange
      return params
    },
    async loadList () {
      this.loading = true
      try {
        const res = await getList(this.buildQuery())
        const data = res.data && res.data.data
        this.tableData = (data && data.records) || []
        this.page.total = (data && data.total) || 0
      } finally {
        this.loading = false
      }
    },
    handleSearch () {
      this.page.currentPage = 1
      this.loadList()
    },
    handleReset () {
      this.query = {}
      this.handleSearch()
    },
    handleSizeChange () {
      this.page.currentPage = 1
      this.loadList()
    },
    openForm (row) {
      this.form = row ? { ...row } : { eventType: 1, urgencyLevel: 4, eventSource: 2 }
      this.formVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    submitForm () {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.actionLoading = true
        try {
          await (this.form.id ? update(this.form) : report(this.form))
          this.$message.success('操作成功')
          this.formVisible = false
          this.loadList()
        } finally {
          this.actionLoading = false
        }
      })
    },
    async openDetail (row) {
      this.detailVisible = true
      this.detailLoading = true
      try {
        const res = await getDetail(row.id)
        this.detail = (res.data && res.data.data) || {}
      } finally {
        this.detailLoading = false
      }
    },
    openPlan (row) {
      this.operationForm = { eventId: row.id, planId: row.planId ? String(row.planId) : '', verifyInfo: '' }
      this.planVisible = true
      this.loadPlanOptions()
    },
    async submitPlan () {
      if (!this.operationForm.planId) return this.$message.warning('请选择预案')
      this.actionLoading = true
      try {
        await reportToAuthority(this.operationForm)
        this.$message.success('操作成功')
        this.planVisible = false
        this.loadList()
      } finally {
        this.actionLoading = false
      }
    },
    async loadPlanOptions (keyword = '') {
      this.planLoading = true
      try {
        const res = await getPlanList({
          page: 1,
          size: 50,
          planName: keyword || undefined,
          planStatus: 1
        })
        const data = res.data && res.data.data
        const records = (data && data.records) || []
        const currentId = this.operationForm && this.operationForm.planId
        if (currentId && !records.some(item => String(item.id) === String(currentId))) {
          this.planOptions = [{ id: currentId, planName: `预案ID：${currentId}` }, ...records]
        } else {
          this.planOptions = records
        }
      } finally {
        this.planLoading = false
      }
    },
    planOptionLabel (item) {
      if (!item) return '-'
      return [item.planName, item.planCode ? `(${item.planCode})` : ''].filter(Boolean).join(' ')
    },
    openResponse (row) {
      this.operationForm = { eventId: row.id, planId: row.planId, responseLevel: row.responseLevel || 3, verifyInfo: '' }
      this.responseVisible = true
    },
    async submitResponse () {
      this.actionLoading = true
      try {
        await startResponse(this.operationForm)
        this.$message.success('操作成功')
        this.responseVisible = false
        this.loadList()
      } finally {
        this.actionLoading = false
      }
    },
    submitStatus (row, type) {
      this.$confirm(type === 'false' ? '确认标记为误报吗？' : '确认手动结束该事件吗？', '提示', { type: 'warning' }).then(async () => {
        const request = type === 'false' ? markFalseAlarm : manualEnd
        await request({ eventId: row.id, verifyInfo: type === 'false' ? '标记误报' : '手动结束' })
        this.$message.success('操作成功')
        this.loadList()
      }).catch(() => {})
    },
    optionLabel (options, value) {
      const item = options.find(option => String(option.value) === String(value))
      return item ? item.label : (value || '-')
    },
    urgencyTag (value) {
      if (Number(value) === 1) return 'danger'
      if (Number(value) === 2) return 'warning'
      if (Number(value) === 3) return 'primary'
      return 'success'
    },
    statusTag (value) {
      if ([4, 5].includes(Number(value))) return 'success'
      if (Number(value) === 6) return 'info'
      if (Number(value) === 3) return 'danger'
      return 'warning'
    },
    stageColor (color) {
      const map = { red: '#f56c6c', yellow: '#e6a23c', green: '#67c23a' }
      return map[color] || color || '#409eff'
    }
  }
}
</script>

<style scoped lang="scss">
.table-toolbar {
  margin-bottom: 10px;
}
.page-bar {
  margin-top: 12px;
  text-align: right;
}
.detail-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-bottom: 18px;
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}
.detail-item {
  display: flex;
  min-height: 40px;
  border-right: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
  span {
    flex: 0 0 90px;
    padding: 10px;
    color: #606266;
    background: #f5f7fa;
  }
  strong {
    flex: 1;
    padding: 10px;
    font-weight: 400;
    word-break: break-all;
  }
}
.detail-item.wide {
  grid-column: span 3;
}
.section-title {
  margin: 16px 0 10px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
  font-weight: 600;
}
.timeline-title {
  font-weight: 600;
}
.timeline-meta,
.timeline-body {
  margin-top: 4px;
  color: #606266;
}
</style>
